export default "__VITE_ASSET__uqrs32ts__"